import { FDV_URL, IDUSUARIO, customAxios } from '../constants';
import { FETCH_AUTORIZACIONES_EXCEPCIONALES, FETCH_SOLICITUD_PEDIDOS } from './types';
import { evalAction, serverError } from '../utils/actionError';

export function fetchAutorizacionesExcepcionales(fdvID) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
      indInactivo: 'S',
      indPaginado: 'S',
      numeroPagina: '1',
      registrosPagina: '10',
    },
    params: {
      numFichaVtaVeh: fdvID,
      codTipoAutExcepcional: '',
      codAreaVta: '',
      codFilial: '',
      codFamiliaVeh: '',
      codMarca: '',
      codEstadoRegul: '',
      codClie: '',
      nomPerso: '',
      fecRegIni: '',
      fecRegFin: '',
      fecEstIni: '',
      fecEstFin: '',
      fecEfeIni: '',
      fecEfeFin: '',
      fecAutIni: '',
      fecAutFin: '',
      codSolicitud: '',
      codEstadoAut: '',
      numProfVeh: '',
      codUsuarioRegul: '',
      vendedor: '',
      indInactivo: 'N',
    },
  };

  const request = customAxios.get(`${FDV_URL}/autorizacion-excepcional/solicitudes`, config)
                          .then(({ data }) => evalAction(data, 'solicitudes'))
                        .catch(error => serverError(error, 'solicitudes'));


  return {
    type: FETCH_AUTORIZACIONES_EXCEPCIONALES,
    payload: request,
  };
}

export function fetchSolicitudPedidos(codSolicitud) {
  const config = {
    headers: {
      idUsuario: IDUSUARIO,
    },
  };

  const request = customAxios.get(`${FDV_URL}/autorizacion-excepcional/solicitudes/${codSolicitud}/pedidos`, config)
                      .then(({ data }) => evalAction(data, 'pedidos'))
                    .catch(error => serverError(error, 'pedidos'));


  return {
    type: FETCH_SOLICITUD_PEDIDOS,
    payload: request,
  };
}



// WEBPACK FOOTER //
// ./src/actions/AutorizacionesExcepcionales.js